<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="$props.name || $props.label"
    :rules="$props.rules"
    tag="div"
  >
    <label v-if="!!$props.label || $slots.label" :for="id">
      <slot name="label">{{ $props.label }}<span v-if="$props.required == true" class="text-danger">*</span> </slot>
    </label>

    <b-input
      v-model="modelValue"
      v-bind="$attrs"
      v-on="$listeners"
      :id="id"
      :name="$props.name"
      :aria-invalid="!!errors"
      class="base-input"
      :class="{ 'is-invalid': !!errors.length }"
    ></b-input>

    <div v-if="!!errors.length" class="invalid-feedback">{{ errors[0] }}</div>
  </ValidationProvider>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import { uniqueId } from 'lodash-es'
import { ValidationProvider } from 'vee-validate'

export default defineComponent({
  name: 'BaseInput',
  inheritAttrs: false,
  components: {
    ValidationProvider
  },
  props: {
    name: String,
    value: [String, Number],
    label: String,
    rules: String,
    required: Boolean
  },
  emits: ['input'],
  setup(props, { emit }) {
    const id = computed(() => `id_${uniqueId('base-input-')}`)

    const modelValue = computed({
      get: () => props.value,
      set: (newValue) => emit('input', newValue)
    })

    return {
      id,

      modelValue
    }
  }
})
</script>
